/** @type {"elements"} */
export const ELEMENTS = "elements";
/** @type {"elementOrder"} */
export const ELEMENT_ORDER = "elementOrder";
/** @type {"pId"} */
export const PARENT_ID = "pId";
/** @type {"states"} */
export const STATES = "states";
